import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body", "chevron"]
  static values = { key: String, active: Boolean }

  connect() {
    const stored = localStorage.getItem(this.storageKey)
    const open = stored === null ? this.activeValue : stored === "open"
    this.setOpen(open)
  }

  toggle() {
    this.setOpen(this.bodyElement.classList.contains("hidden"))
    localStorage.setItem(this.storageKey, this.bodyElement.classList.contains("hidden") ? "closed" : "open")
  }

  setOpen(open) {
    this.bodyElement.classList.toggle("hidden", !open)
    if (this.hasChevronTarget) this.chevronTarget.classList.toggle("rotate-180", open)
  }

  get bodyElement() {
    if (this.hasBodyTarget) return this.bodyTarget

    let body = this.element.querySelector("[data-nav-section-body]")
    if (body) return body

    body = document.createElement("div")
    body.dataset.navSectionBody = "true"
    Array.from(this.element.children).forEach((child) => {
      if (!child.matches("[data-nav-section-header='true']")) body.appendChild(child)
    })
    this.element.appendChild(body)
    return body
  }

  get storageKey() {
    return `taagger.navSection.${this.keyValue}`
  }
}
